// extracted by mini-css-extract-plugin
export default {"select":"header_select__-Gpy6","title":"header_title__j5wSX"};